(function () {
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!canHover || reducedMotion) return;

  var MAX_DEGREES = 7;

  function attach(banner, media) {
    var img = media.querySelector('img');
    if (!img) return;

    function onMove(event) {
      var rect = banner.getBoundingClientRect();
      var x = (event.clientX - rect.left) / rect.width; // 0 -> 1
      var y = (event.clientY - rect.top) / rect.height; // 0 -> 1
      var tiltY = (x - 0.5) * 2 * MAX_DEGREES;
      var tiltX = (0.5 - y) * 2 * MAX_DEGREES;
      img.style.setProperty('--tilt-x', tiltX.toFixed(2) + 'deg');
      img.style.setProperty('--tilt-y', tiltY.toFixed(2) + 'deg');
    }

    function onLeave() {
      img.style.setProperty('--tilt-x', '0deg');
      img.style.setProperty('--tilt-y', '0deg');
    }

    // Listen on the outer .banner, not .banner__media: the transparent
    // .banner__content overlay (heading/buttons) sits on top of the image
    // at z-index: 2 across the whole banner width, so it intercepts
    // pointer events before they'd ever reach .banner__media directly.
    // Events still bubble up to their common ancestor regardless of
    // stacking order, so listening here reliably catches cursor movement
    // over both the image and the text.
    banner.addEventListener('pointermove', onMove);
    banner.addEventListener('pointerleave', onLeave);
  }

  function init() {
    document.querySelectorAll('.animate--tilt-3d').forEach(function (media) {
      var banner = media.closest('.banner');
      if (banner) attach(banner, media);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
